
import Vue from 'vue';

export default Vue.extend({
	name: 'WhiteChip',
	props: {
		styles: { type: [Object, String], default: null },
	},
	data () {
		return {};
	},
});
